import React, { useState } from "react";
import style from "../../Style.module.scss";
import StatusDot from "../../../../components/StatusDot/StatusDot";
import CircularProgress from "../../../../components/CircularProgress/CircularProgress";
import TrendPercent from "../../../../components/TrendPercent/TrendPercent";
import AlertDot from "../../../../components/AlertDot/AlertDot";
import EmptyDot from "../../../../components/AlertDot/EmptyDot";
import ChildRow from "./ChildRow";
import moment from "moment";
import useMerchantStore from "../../../../stores/merchant";
import useCommonStore from "../../../../stores/common";
import useDomainStore from "../../../../stores/domain";
import ReactTooltip from 'react-tooltip'
import { dateFormatter, formatCurrency } from "../../../../../components/helper/helper";

const PROCESSING_COLOR = "#37B450";
const NOT_PROCESSING_COLOR = "#BFBFC3";

function Row({ app }) {
  const { isKurvDomain } = useDomainStore();
  const showDetails = useCommonStore((state) => state.showDetails);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  const setActiveAppId = useMerchantStore((state) => state.setActiveAppId);
  const activeAppId = useMerchantStore((state) => state.activeAppId);

  const [childAppOpen, setChildAppOpen] = useState(false);

  const processAlert = (alert) => {
    if (!alert) return '';
    let alertList = alert.split('\n');
    alertList?.pop()
    let list = `<ul>${alertList.map(item => `<li>${item}</li>`).join('')}</ul>`;
    return list;
  }

  return (
    <>
      <tr
        onClick={() => {
          setActiveAppId(app.id);
          setShowDetails(true);
        }}
        className={`${activeAppId == app.id ? style.active_app : ""} ${isKurvDomain ? style.kurv_theme : ""}`}
      >
        <td>
          {/* <ButtonIcon onClick={(e) => { setChildAppOpen(!childAppOpen); e.stopPropagation(); }}>
            <CaretRight className={`${style.caret_icon} ${childAppOpen ? style.rotate_90 : ""}`} />
          </ButtonIcon> */}
        </td>
        <td>{app.field_dba}</td>
        <td>{app?.merchant_details?.mid}</td>
        <td className={style.centerStatusDot} >
          {app?.merchant_details?.status == 'O' ? (
            <StatusDot color={PROCESSING_COLOR} />
          ) : (
            <StatusDot color={NOT_PROCESSING_COLOR} />
          )}
        </td>
        {!showDetails && <td>${formatCurrency(app?.merchant_details?.volume_cap)}</td>}
        <td>
          <CircularProgress value={app?.merchant_details?.volume_used} />
        </td>
        <td>${formatCurrency(app?.merchant_details?.volume_mtd)}</td>
        {!showDetails && (
          <td>
            <TrendPercent percent={app?.merchant_details?.mom_change} />
          </td>
        )}
        {!showDetails && (
          <td>
            {dateFormatter(app?.merchant_details?.date_approved)}
          </td>
        )}
        <td data-tip data-for={`alert_tooltip_${app?.id}`} >
          {app?.merchant_details?.alert ? (
            <>
              <AlertDot />
              <ReactTooltip id={`alert_tooltip_${app?.id}`} html={true} >
                {processAlert(app?.merchant_details?.alert)}
              </ReactTooltip>
            </>
          ) : (
            <div style={{ marginLeft: '6px' }}>
              <EmptyDot />
            </div>
          )}
        </td>
      </tr>
      {childAppOpen && <ChildRow />}
    </>
  );
}

export default Row;
